export default __webpack_public_path__ + "static/media/listing-price.9c93d766.svg";